import { SearchSuggestionTownsAndCityLinks } from '@zoopla/listing-search/suggested-towns-and-cities';
import { NewHomesPageSubtitleShort } from '../NewHomesPageSubtitleShort';
import { newHomesTownsAndCityData } from './NewHomesTownsAndCitiesLinks.data';
import {
    trackIndividualLocationNewHomes,
    trackSeeAllUKNewHomes
} from './NewHomesTownsAndCitiesLinks.tracking';

export const NewHomesTownsAndCitiesLinks = () => (
    <>
        <NewHomesPageSubtitleShort>
            Popular locations for new homes
        </NewHomesPageSubtitleShort>
        <SearchSuggestionTownsAndCityLinks
            areas={newHomesTownsAndCityData}
            trackSeeAll={trackSeeAllUKNewHomes}
            trackSeeIndividual={trackIndividualLocationNewHomes}
        />
    </>
);
